// eslint-disable-next-line import/prefer-default-export
export const addCloudinaryAutoFormat = (urlString) => {
  if (!urlString) return null;

  const urlPieces = urlString.split('/');
  const insertPosition = urlPieces.indexOf('upload');
  urlPieces.splice(insertPosition + 1, 0, 'f_auto');
  return urlPieces.join('/');
};
